import React from "react";
import DataTable from "react-data-table-component";
import { ClipLoader, PropagateLoader } from "react-spinners";
import { MdDelete, MdEdit } from "react-icons/md";
import NoData from "../../../../atoms/NoData";
import Button from "../../../../atoms/Button";
import FileActions from "./FileActions";
import { FaEye, FaFileDownload, FaFileUpload } from "react-icons/fa";
import useModal from "../../../../../hooks/useModal";
import Modal from "../../../../molecules/Modal";
import { SiMinutemailer } from "react-icons/si";
import HowSendEmail from "./HowSendEmail";

const DocumentTable = ({
    padresActivos,
    loading,
    loading2,
    user,
    expandedRowKey,
    handleRowExpandToggled,
    handleOpenDeleteMulti,
    handleOpenEditDate,
    handleOpenDocument,
    handleDownloadDocument,
    handleOpenDelete,
    handleOpenUpload,
}) => {
    const { open, close, isOpen } = useModal();
    const conditionalRowStyles = [{ when: row => row?.key === expandedRowKey, style: { backgroundColor: '#d2effa', }, }];

    const columns = [
        { name: "Fecha de los documentos", selector: row => row.fecha },
        { name: "Tipo de archivo(s)", selector: row => row.types },
        {
            name: "Nombre(s) de archivo(s)",
            cell: row => {
                const archivosFiltrados = row.archivos?.filter(file => file.activo && file.title) || [];
            
                if (archivosFiltrados.length === 0) {
                    return <span>Sin archivos</span>;
                }
            
                return (
                    <div className="flex flex-col gap-1">
                    {archivosFiltrados.map((file, index) => {
                        const isSubido = Boolean(file.s3Key);
                        const texto = file.title;
            
                        return (
                        <span
                            key={index}
                            className={isSubido ? "font-bold text-black" : "text-red-600"}
                        >
                            {texto}
                        </span>
                        );
                    })}
                    </div>
                );
            },
            wrap: true,
          }
    ];

    const columnsResponsive = [
        {
            name: "Información", cell: row => (
                <div className="flex flex-col">
                    <p>Fecha: {row.fecha} </p>
                    <p> Tipo de archivo(s): {row.types} </p>
                    {row.archivos?.filter(file => file.activo && file.title).length > 0 ? (
                        <ul className="list-disc list-inside mt-1 text-sm text-gray-700">
                            {row.archivos
                                .filter(file => file.activo && file.title)
                                .map((file, index) => (
                                    <li key={index}>{file.title}</li>
                                ))}
                        </ul>
                    ) : (
                        <p className="text-sm text-gray-500">Sin archivos</p>
                    )}
                </div>
            )
        },
    ];

    if (user?.role !== "Client") {
        columns.push({
            name: "Acciones",
            cell: row => (
                <div className="flex flex-row space-x-2">
                    <Button 
                        text={<MdEdit size={22} />} 
                        bgColor="blue" 
                        width="w-10" 
                        onClick={() => handleOpenEditDate(row)} 
                        disabled={loading2} 
                    />
                    <Button text={<MdDelete size={22} />} bgColor="red" width="w-10" onClick={() => handleOpenDeleteMulti(row)} disabled={loading2} />
                </div>
            ),
            width:"150px",
        });
    }

    const ExpandedComponent = ({ data }) => {
        const archivosActivos = data?.archivos?.filter(file => file.activo)?.map(file => {
            if (!file.s3Key) {
                return { ...file, fechaPadre: data.fecha };
            }
            return file;
        });
    
        return (
            <div className="p-2 w-full flex flex-col justify-center items-center border-2 border-sky-200 border-t-0 rounded-b-lg">
                {user?.role !== "Client" &&
                    <Button text={<MdDelete size={22} />} bgColor="red" width="w-10" onClick={() => handleOpenDelete(data)} />
                }
                <DataTable
                    data={archivosActivos}
                    columns={getColumnsArchivosResponsive(user, loading2, handleOpenDocument, handleDownloadDocument, handleOpenDelete, handleOpenUpload, open)}
                    progressPending={loading}
                    progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                    noDataComponent={<NoData />}
                />
            </div>
        );
    };
    

    return (
        <>
            <div className="block lg:hidden">
                <DataTable
                    data={padresActivos}
                    columns={columnsResponsive}
                    progressPending={loading}
                    progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                    noDataComponent={<NoData />}
                    pagination
                    expandableRows
                    expandOnRowClicked
                    expandableRowExpanded={row => row.key === expandedRowKey}
                    onRowExpandToggled={handleRowExpandToggled}
                    conditionalRowStyles={conditionalRowStyles}
                    expandableRowsComponent={ExpandedComponent}
                />
            </div>
            <div className="hidden lg:block">
                <DataTable
                    data={padresActivos}
                    columns={columns}
                    progressPending={loading}
                    progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                    noDataComponent={<NoData />}
                    pagination
                    expandableRows
                    expandOnRowClicked
                    expandableRowExpanded={row => row.key === expandedRowKey}
                    onRowExpandToggled={handleRowExpandToggled}
                    conditionalRowStyles={conditionalRowStyles}
                    expandableRowsComponent={({ data }) => {
                        const archivosActivos = data?.archivos?.filter(file => file.activo);
                        return (
                            <div className="border border-sky-200  border-t-0 rounded-b-xl mb-1">
                                <DataTable
                                    data={archivosActivos}
                                    columns={getColumnsArchivos(user, loading2, handleOpenDocument, handleDownloadDocument, handleOpenDelete, handleOpenUpload)}
                                    progressPending={loading}
                                    progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                                    noDataComponent={<NoData />}
                                />
                            </div>
                        );
                    }}
                />
            </div>
            {isOpen &&
                    <Modal onClose={close} title="Enviar por correo" >
                        <HowSendEmail/>
                    </Modal>
            }
        </>
    );
};

export default DocumentTable;

const getColumnsArchivos = (user, loading2, handleOpenDocument, handleDownloadDocument, handleOpenDelete, handleOpenUpload) => [
    { name: "Nombre", selector: row => row.title || "No hay archivo cargado" },
    { name: "Tipo de archivo", selector: row => row.typeFile },
    { name: "Actualizó", selector: row => row.user },
    {
        name: "Acciones", cell: row => (
            <FileActions
                file={row}
                loading2={loading2}
                user={user}
                onOpenDocument={handleOpenDocument}
                onDownloadDocument={handleDownloadDocument}
                onDeleteFile={handleOpenDelete}
                onUploadFile={handleOpenUpload}
            />
        )
    },
];

const getColumnsArchivosResponsive = (user, loading2, handleOpenDocument, handleDownloadDocument, handleOpenDelete, handleOpenUpload, open) => [
    {
        name: "Archivos", cell: row => (
            row.s3Key ?
                <div className="w-full flex flex-col">
                    <p> {row.title || "No hay archivo cargado"} </p>
                    <p> Tipo: {row.typeFile} </p>
                    <p> Actualizó {row.user} </p>
                    <div className="w-full flex flex-row justify-between">
                        <Button text={loading2 ? <ClipLoader color="white"/> : <FaEye size={22} />} bgColor="blue" width="w-10" onClick={() => handleOpenDocument(row.s3Key, row.typeFile)} disabled={loading2} />
                        <Button text={loading2 ? <ClipLoader color="white"/> : <FaFileDownload size={22} />} bgColor="green" width="w-10" onClick={() => handleDownloadDocument(row.s3Key)} disabled={loading2} />
                        <Button text={loading2 ? <ClipLoader color="white"/> : <SiMinutemailer size={22} />} bgColor="black" width="w-10" onClick={open} disabled={loading2} />
                        {user?.role !== "Client" &&
                            <Button text={loading2 ? <ClipLoader color="white"/> : <MdDelete size={22} />} bgColor="red" width="w-10" onClick={() => handleOpenDelete(row)} disabled={loading2} />
                        }
                    </div>
                </div>
                :
                <div className="w-full flex flex-col">
                    <p className={`${row.activo === false ? "text-green-700" : "text-red-500"}`}> {row.title || "No hay archivo cargado"} </p>
                    <p> Tipo: {row.typeFile} </p>
                    <p> Actualizó: {row.user} </p>
                    {user?.role !== "Client" &&
                        <Button text={<FaFileUpload size={22} />} bgColor="blue" width="w-10 m-auto" onClick={() => handleOpenUpload(row)} disabled={loading2} />
                    }
                </div>
        )
    },
];